function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FEFEFE",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M7.096 1.819c-2.91 0-5.276 2.349-5.276 5.236v10.57c0 2.887 2.367 5.236 5.276 5.236h9.98c2.91 0 5.277-2.35 5.277-5.237V7.055c0-2.887-2.367-5.236-5.277-5.236h-9.98zm9.98 22.848h-9.98C3.183 24.667 0 21.507 0 17.624V7.055C0 3.172 3.183.013 7.096.013h9.98c3.913 0 7.096 3.16 7.096 7.042v10.57c0 3.882-3.183 7.042-7.096 7.042z"
}), React.createElement("path", {
  d: "M11.733 7.947a4.079 4.079 0 0 0-2.856 1.177 4.446 4.446 0 0 0-1.34 3.172 4.352 4.352 0 0 0 4.347 4.347c2.385 0 4.294-1.92 4.348-4.37.027-1.237-.329-2.285-1.028-3.032-.753-.804-1.912-1.25-3.352-1.292a3.992 3.992 0 0 0-.119-.002m.151 10.905a6.564 6.564 0 0 1-6.556-6.556c0-1.782.732-3.516 2.01-4.757 1.245-1.21 2.871-1.849 4.579-1.799 2.041.06 3.735.748 4.899 1.99 1.103 1.177 1.665 2.765 1.625 4.59a6.72 6.72 0 0 1-1.942 4.609 6.454 6.454 0 0 1-4.615 1.923M20.492 5.533a1.434 1.434 0 1 1-2.87 0 1.434 1.434 0 0 1 2.87 0"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/instagram.ddf660ed.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/containers/static/instagram.svg
// module id = 380
// module chunks = 0